import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/chem_analytics.py
export const CHEMISTRY_ANALYTICS_ACTIONS = {
  UPLOADED_FILE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'uploaded_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'created_molecule',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'edited_molecule',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'archived_molecule',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'unarchived_molecule',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'deleted_molecule',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'viewed_molecule',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_MOLECULE: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'downloaded_molecule',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PERFORMED_SUBSTRUCTURE_SEARCH: {
    module: ANALYTICS_MODULE.CHEMISTRY,
    action: 'performed_substructure_search',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
